import React, { Component } from "react";
import {
  CardFooterWrapper,
  VideoEditConatiner,
  VideoEditIcon,
  VideoEditText,
  DeleteIcon,
  DownloadIcon,
  WaterMarkIcon,
  GIFDownloadIcon,
  ShareIcon,
  InfoIcon,
  RightContainer
} from "./MyVideoCardFooter.style";
import i18n from '../../../i18n';
import DataManager from "@/utils/DataManager";
import Validator from "@/utils/Validator"

import { connect } from 'react-redux'

class MyVideoCardFooterClass extends Component {

  render() {
    const {
      lang,
      onVideoEditClicked,
      onDownloadClicked,
      onDeleteClicked,
      onRemoveWaterMark,
      video,
      isExistPayment,
      paymentMode,
      onVideoInfoOpen
    } = this.props;

    if(!video) return;

    const {
      paymentInfo,
      isEditable,
      state
    } = video;

    const isNoPayment = !isExistPayment || !isEditable;
    const isWatermarkRemove = isNoPayment && paymentInfo.isNoPayment && state === "Finish" && paymentInfo && !paymentInfo.isWatermarkRemoved
    let isStoreExpired = false
    if (video.provider !== "cafe24") isStoreExpired = Validator.Boolean(video.isStoreExpired) ? video.isStoreExpired : true

    return (
      <CardFooterWrapper>
        <VideoEditConatiner onClick={onVideoEditClicked} isStoreExpired={isStoreExpired}>
          {
            !isStoreExpired && <>
              <VideoEditIcon src="https://front.videomonster.com/images-u6yd72dy/web/myvideofooter/video_edit.svg" title={i18n.t("myvideocardfooter.icon.title1")} />
              <VideoEditText>{i18n.t("myvideocardfooter.text")}</VideoEditText>
            </>
          }
        </VideoEditConatiner>
        
        <RightContainer>
        {
          lang === 'ko' && isWatermarkRemove && onRemoveWaterMark && !isStoreExpired &&
          <WaterMarkIcon
            src="https://front.videomonster.com/images-u6yd72dy/web/myvideofooter/watermarkicon.svg"
            onClick={() => onRemoveWaterMark(video)}
            title={i18n.t("myvideocardfooter.icon.title5")}
          />
        }
        <InfoIcon
          src="https://front.videomonster.com/images-u6yd72dy/web/myvideofooter/info.svg"
          onClick={() => onVideoInfoOpen(video)}
          title={i18n.t("myvideocardfooter.icon.title2")}
        />
        <DownloadIcon
          src="https://front.videomonster.com/images-u6yd72dy/web/myvideofooter/outline-save.svg"
          onClick={() => onDownloadClicked(video._id, video.name, video.isDownloadable)}
          title={i18n.t("myvideocardfooter.icon.title2")}
        />
        <DeleteIcon
          src="https://front.videomonster.com/images-u6yd72dy/web/myvideofooter/video_delete.svg"
          onClick={onDeleteClicked}
          title={i18n.t("myvideocardfooter.icon.title3")}
        />
        </RightContainer>
       
      </CardFooterWrapper>
    );
  }
}

const mapStateToProps = state => ({
  lang: state.langStore.lang,
  paymentMode: state.paymentModeStore.paymentMode
})

export const MyVideoCardFooter = connect(
  mapStateToProps,
  null
)(MyVideoCardFooterClass)